import PageHeader from 'components/global/PageHeader';

const ColoradoLoginTitle = () => {
  return <PageHeader title="Log In to ECHO Knowledge" />;
};

export default ColoradoLoginTitle;
